import { Alert } from '@mui/lab';
import ActionLink from 'components/action-link/action-link.component';
import React from 'react';
import { Fade as RevealFade } from 'react-awesome-reveal';
import { useTranslation } from 'react-i18next';
import * as S from '../checkout-offers-section.styles';
import { selectApplicableOffers } from 'redux/cart/cart.selectors';
import { useSelector } from 'react-redux';

const CheckoutOffersSectionApplicable = ({ openModal }) => {
  const applicableOffers = useSelector(selectApplicableOffers);
  const { t } = useTranslation();

  return (
    <RevealFade direction="right" duration={600} triggerOnce>
      <Alert
        severity="success"
        icon={<S.CustomCertificate />}
        data-testid="OffersSection"
      >
        <ActionLink
          onClick={openModal}
          data-testid="OffersSection.ActionLink.ApplicableOffers"
        >
          {t('checkout.offers.applicable', { count: applicableOffers.length })}
        </ActionLink>
      </Alert>
    </RevealFade>
  );
};

export default CheckoutOffersSectionApplicable;
